import {inventoryConstants} from "../../../../constants/Network/inventory.constants";

const initialState = {
    fetching:false,
    getCpa : [],
    error : {},

    fetchingDaily:false,
    getCpaDaily : [],
    errorDaily : {},

    fetchingSyncCompetitor: false,
    syncCompetitor : [],
    errorSyncCompetitor : {},

    prices: {},
    loading: {},
    errors: {},

    cpaPromotionAvailableFetching: false,
    cpaPromotionAvailable: null,
    cpaPromotionAvailableError: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case inventoryConstants.GET_CPA_COMPETITOR_PENDING:
            return {
                ...state,
                fetching: true,
                getCpa: [],
                error : {},
            };
        case inventoryConstants.GET_CPA_COMPETITOR_FULFILLED:
            return {
                ...state,
                fetching: false,
                getCpa : action.payload
            };
        case inventoryConstants.GET_CPA_COMPETITOR_REJECTED:
            return {
                ...state,
                error: action.payload,
                fetching: false,
                getCpa: [],
            };

        case inventoryConstants.CPA_DAILY_PRICE_PENDING: {
            const { identifier } = action.payload;
            return {
                ...state,
                loading: { ...state.loading, [identifier]: true },
                error: { ...state.errors, [identifier]: false },
            };
        }

        case inventoryConstants.CPA_DAILY_PRICE_FULFILLED: {
            const { identifier, data } = action.payload;
            return {
                ...state,
                prices: { ...state.prices, [identifier]: data },
                loading: { ...state.loading, [identifier]: false },
            };
        }
        case inventoryConstants.CPA_DAILY_PRICE_REJECTED: {
            const { identifier } = action.payload;
            return {
                ...state,
                loading: { ...state.loading, [identifier]: false },
                error: { ...state.errors, [identifier]: true },
            };
        }
        case inventoryConstants.GET_CPA_COMPETITOR_CLEAR_DATA:
            return {
                ...state,
                fetchingDaily: true,
                getCpaDaily: false,
                errorDaily : {},
            };
        case inventoryConstants.SYNC_CPA_COMPETITOR_PENDING:
            return {
                ...state,
                fetchingSyncCompetitor: true,
                syncCompetitor: [],
                errorDaily : {},
            };
        case inventoryConstants.SYNC_CPA_COMPETITOR_FULFILLED:
            return {
                ...state,
                fetchingSyncCompetitor: false,
                syncCompetitor : action.payload
            };
        case inventoryConstants.SYNC_CPA_COMPETITOR_REJECTED:
            return {
                ...state,
                errorSyncCompetitor: action.payload,
                fetchingSyncCompetitor: false
            };
        case inventoryConstants.SYNC_CPA_COMPETITOR_CLEAR_DATA:
            return {
                ...state,
                fetchingSyncCompetitor: false,
                syncCompetitor : false,
                errorSyncCompetitor : {},
            };
        case 'CPA_PROMOTION_AVAILABLE_PENDING':
            return {
                ...state,
                cpaPromotionAvailableFetching: true,
                cpaPromotionAvailable: null,
                cpaPromotionAvailableError: null,
            };
        case 'CPA_PROMOTION_AVAILABLE_FULFILLED':
            return {
                ...state,
                cpaPromotionAvailableFetching: false,
                cpaPromotionAvailable: action.payload,
                cpaPromotionAvailableError: null,
            };
        case 'CPA_PROMOTION_AVAILABLE_REJECTED':
            return {
                ...state,
                cpaPromotionAvailableFetching: false,
                cpaPromotionAvailable: null,
                cpaPromotionAvailableError: action.payload,
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            }
        default:
            return state
    }
}
